// NOT standard shadcn. Retool supplied this from its runtime.
//
// Reconstructed from usage: a plain <select> styled to match Input, taking
// <option> children directly. Used in EditOwnerDialog, EditDriverDialog and
// EditVehicleDialog where shadcn's Radix-based Select would be heavier than the
// job needs.
import * as React from 'react'
import { cn } from './utils'

export const NativeSelect = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, children, ...props }, ref) => (
  <select
    ref={ref}
    className={cn(
      'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors',
      'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
      'disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    {...props}
  >
    {children}
  </select>
))
NativeSelect.displayName = 'NativeSelect'
